// extracted by mini-css-extract-plugin
export default {"content":"pUumb","error":"H63Y7"};